module.exports = __webpack_public_path__ + "mobile/img/ipswitch-img2.c30b272f.png";